<template>
  <footer
    class=""
    :class="{ [`footer-${type}`]: type }"
  >
    <div class="footer-wrap">
      <div class="footer-logo-wrap">
        <img v-lazy="'/img/renewal/footer_logo.png'" />
      </div>
      <div class="footer-info">
        <ul>
          <li>
            <a href="mailto://info@nplusent.com">
              Contact : info@nplusent.com
          </a>
        </li>
        <li>
          <a href="//docs.google.com/document/d/1qWC4AO6xt8doM3EI3MROQWcwcX_k7qaEzPHitSFcuZA/edit?usp=sharing" style="margin: 5px;" target="_blank">
            Privacy Policy
          </a>
        </li>
        <li>
          <a href="//docs.google.com/document/d/1OCUgA-HX8fs-kRebtNvTD1wDvi-broe10adSVWm6to4/edit?usp=sharing" style="margin: 5px;" target="_blank">
            Terms of use
          </a>
        </li>
        </ul>
        <div class="copy">
          &copy; {{ year }}, NPLUS ENTERTAINMENT PTE. LTD
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
  footer {
    height: 100px;
    padding: 30px 40px;
    background-color: #000;
  }
  .footer-wrap {
    display: flex;
  }
  .footer-logo-wrap {
    margin: 0 120px 0 0;
  }
  .footer-info {
    display: flex; justify-content: space-between; align-items: center;
    width: 100%;
  }
  .footer-info ul {
    display: flex; align-items: center;
    gap: 60px;
    margin: 0; padding: 0;
  }
  .footer-info ul li a {
    position: relative;
    color: #535363; font-size: 13px; font-weight: 500; letter-spacing: -0.13px;
    transition: all ease 0.1s;
  }
  .footer-info ul li a:hover {
    text-decoration: none;
    color: #fff;
    transition: all ease 0.1s;
  }
  .footer-info ul li a::after {
    content: '';
    display: block;
    position: absolute; top: 50%; right: -35px; transform: translateY(-50%);
    width: 1px; height: 12px;
    background-color: #262a38;
  }
  .copy {
    color: #545463; font-size: 13px; font-weight: 500; letter-spacing: -0.13px;
    cursor: default;
  }
  .footer-logo-wrap img {
    max-width: 90px;
  }
  @media screen and (max-width:767px) {
    body footer {
      height: auto;
    }
    .footer-wrap {
      flex-direction: column;
    }
    .footer-logo-wrap {
      margin: 0 auto 20px;
    }
    .footer-info {
      flex-direction: column;
    }
    .footer-info ul {
      flex-direction: column;
      gap: 10px;
    }
    .copy {
      margin: 10px 0 0;
    }
  }
</style>
